import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from './Auth';
import NotificationModule from './Notification';
import UserModule from './User';
import ArtistModule from './Artist';
import EmailModule from './Email';
import SongModule from './Song';
import TermsOfConditionModule from './TermsOfCondition';
import IAPModule from './IAP';
import AlbumModule from './Album';
import TransactionModule from './Transaction';
import FinanceModule from './Finance';
import StatisticModule from './Statistic';
import CreditsAmountModule from './CreditsAmount';
import TransactionAdminModule from './TransactionAdmin';
import SubscriptionModule from './Subscription';
import AppSettingModule from './AppSetting';
import PlaylistModule from './Playlist';
import RatingSurveyModule from './RatingSurvey';
import MissionsVideosModule from './MissionsVideos';
import CategoriesModule from './Categories';
import HomeSectionModule from './HomeSection';
import ReferralDataModule from './ReferralData';
import CLTVModule from './CLTV';
import VideoPageModule from './VideoPage';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    AuthModule,
    NotificationModule,
    UserModule,
    EmailModule,
    ArtistModule,
    SongModule,
    TermsOfConditionModule,
    IAPModule,
    AlbumModule,
    TransactionModule,
    FinanceModule,
    StatisticModule,
    CreditsAmountModule,
    TransactionAdminModule,
    SubscriptionModule,
    AppSettingModule,
    PlaylistModule,
    RatingSurveyModule,
    MissionsVideosModule,
    CategoriesModule,
    HomeSectionModule,
    ReferralDataModule,
    CLTVModule,
    VideoPageModule,
  },
});



// WEBPACK FOOTER //
// ./src/stores/index.js